import { eventbus } from '@/core/eventbus'
import type { Handler } from 'mitt'
import { onBeforeUnmount, onMounted } from 'vue'

export function useMenuMessage(_sender: string) {
  const subscribes: [string, Handler][] = []

  function EnableMenuCommand(id: string) {
    eventbus.emit('Map.Menu.EnableMenuCommand', { id, _sender })
  }

  function DisableMenuCommand(id: string) {
    eventbus.emit('Map.Menu.DisableMenuCommand', { id, _sender })
  }

  function onEnableMenuCommand(handler: Handler) {
    subscribes.push(['Map.Menu.EnableMenuCommand', handler])
  }

  function onDisableMenuCommand(handler: Handler) {
    subscribes.push(['Map.Menu.DisableMenuCommand', handler])
  }

  onMounted(() => {
    subscribes.forEach(([type, handler]) => eventbus.on(type, handler))
  })

  onBeforeUnmount(() => {
    subscribes.forEach(([type, handler]) => eventbus.off(type, handler))
  })

  return {
    EnableMenuCommand,
    DisableMenuCommand,
    onEnableMenuCommand,
    onDisableMenuCommand,
  }
}
